import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	ManpowerVehiclesApiService,
	AddVehicleBody,
	UpdateVehicleBody,
} from '../../../services/manpowerVehiclesApi';

const LIST_KEY = ['manpower', 'vehicles', 'listing'];

/** Add / update / soft-delete vehicle mutations, each invalidating the list on success. */
export const useVehicleMutations = () => {
	const queryClient = useQueryClient();
	const invalidate = () => queryClient.invalidateQueries({ queryKey: LIST_KEY });

	const create = useMutation({
		mutationFn: ({ vendorId, body }: { vendorId: number; body: AddVehicleBody }) =>
			ManpowerVehiclesApiService.addVehicle(vendorId, body),
		onSuccess: invalidate,
	});

	const update = useMutation({
		mutationFn: ({ id, body }: { id: number; body: UpdateVehicleBody }) =>
			ManpowerVehiclesApiService.updateVehicle(id, body),
		onSuccess: invalidate,
	});

	const remove = useMutation({
		mutationFn: (id: number) => ManpowerVehiclesApiService.deleteVehicle(id),
		onSuccess: invalidate,
	});

	return { create, update, remove };
};
